let disposeHeader=()=>{};
let header;
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
const topButton=document.querySelector('[data-back-to-top]');
function setupHeader(){
  disposeHeader();
  header=document.querySelector('.toutera-header-section');
  if(!header)return;
  const shell=header.querySelector('.header-shell')||header;
  const events=new AbortController();
  let lastY=Math.max(0,window.scrollY),distance=0,direction=0,frame=0,fullHeight=0,headerTop=0,compact=false;
  const show=()=>{header.classList.remove('is-scroll-hidden');distance=0;};
  const measure=()=>{
    const wasCompact=header.classList.contains('is-compact');
    if(wasCompact)header.classList.remove('is-compact');
    const height=shell.offsetHeight;
    if(height){fullHeight=height;header.style.setProperty('--full-header-height',height+'px');}
    headerTop=header.getBoundingClientRect().top+window.scrollY;
    if(wasCompact)header.classList.add('is-compact');
    header.classList.add('is-header-ready');
  };
  const setCompact=value=>{
    if(value===compact)return;
    compact=value;
    header.classList.add('is-mode-changing');
    header.classList.toggle('is-compact',compact);
    if(compact)header.classList.add('is-scroll-hidden');
    else show();
    void shell.offsetHeight;
    header.classList.remove('is-mode-changing');
  };
  const resize='ResizeObserver' in window?new ResizeObserver(()=>{if(!compact)measure();}):null;
  measure();resize?.observe(shell);
  const update=()=>{
    frame=0;
    if(document.documentElement.classList.contains('modal-open'))return;
    const y=Math.max(0,Math.min(window.scrollY,document.documentElement.scrollHeight-window.innerHeight));
    const delta=y-lastY;lastY=y;
    setCompact(y>=headerTop+fullHeight && fullHeight>0);
    header.classList.toggle('is-scrolled',y>8);
    if(topButton){const visible=y>320;topButton.classList.toggle('is-visible',visible);topButton.disabled=!visible;}
    const active=document.activeElement;
    const engaged=header.contains(active)&&(active.matches('input,textarea,select,[contenteditable="true"]')||active.matches(':focus-visible'));
    if(!compact||engaged){show();return;}
    if(Math.abs(delta)<1)return;
    const next=delta>0?1:-1;
    distance=next===direction?distance+Math.abs(delta):Math.abs(delta);direction=next;
    if(distance>=16){header.classList.toggle('is-scroll-hidden',next>0);distance=0;}
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
  window.addEventListener('scroll',schedule,{passive:true,signal:events.signal});
  window.addEventListener('resize',()=>{measure();schedule();},{passive:true,signal:events.signal});
  window.addEventListener('pageshow',()=>{lastY=Math.max(0,window.scrollY);show();schedule();},{signal:events.signal});
  header.addEventListener('focusin',show,{signal:events.signal});
  document.addEventListener('keydown',event=>{if(event.key==='Tab')show();},{signal:events.signal});
  if(topButton)topButton.hidden=false;
  update();
  disposeHeader=()=>{events.abort();resize?.disconnect();cancelAnimationFrame(frame);};
}
topButton?.addEventListener('click',()=>{
  document.querySelector('#main')?.focus({preventScroll:true});
  header?.classList.remove('is-scroll-hidden');
  window.scrollTo({top:0,behavior:reduced.matches?'instant':'smooth'});
});
setupHeader();
document.addEventListener('shopify:section:load',event=>{if(event.target.matches('.toutera-header-section'))setupHeader();});
document.addEventListener('shopify:section:unload',event=>{if(event.target===header)disposeHeader();});

const siteBack=document.querySelector('[data-site-back]');
siteBack?.addEventListener('click',event=>{
  try{
    const previous=new URL(document.referrer);
    if(previous.origin===window.location.origin&&window.history.length>1){
      event.preventDefault();
      window.history.back();
    }
  }catch{}
});
